import TripItemFerry from './trip-item-ferry-component';
import TripItemFerryService from './trip-item-ferry-service';

import './trip-item-ferry.scss';

const MODULE_NAME = 'app.trip.item-ferry';
const module = angular.module(MODULE_NAME, [])
    .directive(TripItemFerry.DIRECTIVE_NAME, TripItemFerry)
    .service(TripItemFerryService.SERVICE_NAME, TripItemFerryService);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/trip/trip-item-ferry/trip-item-ferry-module.js